/* eslint-disable react/jsx-no-constructed-context-values */
/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import PropTypes from "prop-types";

import useTreeState from "./useTreeState";
import TreeNode from "./TreeNode";
import ConfigContext from "./context";

import "./FolderTree.scss";

const FolderTree = ({
	data,
	onChange,
	initCheckedStatus,
	initOpenStatus,
	showCheckbox,
	indentPixels,
	onNameClick,
	readOnly,
}) => {
	const options = {
		initCheckedStatus,
		initOpenStatus,
	};

	const { treeState, reducers } = useTreeState({ data, options, onChange });
	const { checkNode, toggleOpen } = reducers;

	if (!treeState) return null;

	const configs = {
		handleCheck: checkNode,
		handleToggleOpen: toggleOpen,
		onNameClick,
		indentPixels,
		showCheckbox,
		readOnly,
	};

	return (
		<div className="folder-tree">
			<ConfigContext.Provider value={configs}>
				<ul className="root">
					<TreeNode
						key={treeState._id}
						path={[]}
						{...treeState}
					/>
				</ul>
			</ConfigContext.Provider>
		</div>
	);
};

FolderTree.propTypes = {
	data: PropTypes.object.isRequired,
	onChange: PropTypes.func,
	initCheckedStatus: PropTypes.string,
	initOpenStatus: PropTypes.string,
	indentPixels: PropTypes.number,
	onNameClick: PropTypes.func,
	showCheckbox: PropTypes.bool,
	readOnly: PropTypes.bool,
};

FolderTree.defaultProps = {
	onChange: () => {},
	initCheckedStatus: "unchecked",
	initOpenStatus: "open",
	indentPixels: 20,
	onNameClick: null,
	showCheckbox: true,
	readOnly: false,
};

export default FolderTree;
